import api from "../../api";

const $ = jQuery;

function observe( entries, config ){
	let timeout = 0;
	let delay = 0;
	entries
		.filter( entry => entry.isIntersecting )
		.sort((a,b) => {
			const aRect = a.target.getBoundingClientRect();
			const bRect = b.target.getBoundingClientRect();

			if( aRect.y < bRect.y ){
				return -1;
			}
			if( aRect.y > bRect.y ){
				return 1;
			}
			else {
				if( aRect.x < bRect.x ){
					return -1;
				}
				else if( aRect.x > bRect.x ){
					return 1;
				}
			}
			return 0;
		})
		.forEach( (entry, i) => {
			if( i ) {
				delay += (200 * ((10-Math.min(9,i)) / 10) );
			}
			setTimeout( 
				() => entry.target.classList.add('show'), 
				delay
			);
		});

	entries
		.filter( entry => !entry.isIntersecting )
		.forEach( (entry, i) => {
			// entry.target.classList.remove('show');
		});
}

const observer = new IntersectionObserver( observe, {
	rootMargin: '0px 0px 0px 100px'
});

export default {
    init(el, config){
        observer.observe(el, config);
    }
}